import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import { PureTranslator } from 'ggApp/modules/translator/components';
import FintecSystemsIcon from 'ggApp/shared/icons/FintecSystems';
import { Root, ContentWrapper, Text, Loader } from './styles';

const SepaRedirectPreflight = () => {
    const theme = useContext(ThemeContext);

    return (
        <Root>
            <ContentWrapper>
                <Loader />
                <Text>
                    <PureTranslator tk="PAYMENT_REDIRECT_PREFLIGHT_MSG_SEPA" />
                </Text>
            </ContentWrapper>
            <FintecSystemsIcon width="132px" light={theme.mode === 'dark'} />
        </Root>
    );
};

export default SepaRedirectPreflight;
